import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
// import { Link } from "gatsby"
import { FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa"
import { StaticImage } from "gatsby-plugin-image"

const Footer = ({ siteTitle, menu, service }) => (
  <footer className="bg-primary py-12 md:py-20">
    <div className="max-w-6xl mx-auto w-11/12 xl:w-full grid  lg:grid-cols-3 gap-4 lg:gap-8">
      <div className="grid lg:w-48 text-center divide-y divide-gray-300 divide-opacity-25">
        <div className="pb-3">
          <Link to="/">
            <StaticImage
              src="../../images/logo.png"
              className="h-20 w-36"
              alt="The Orchid Group"
            />
            <span className="sr-only">{siteTitle}</span>
          </Link>
        </div>
        <ul className="flex gap-6 text-white justify-center py-4">
          <li>
            <a
              rel="noreferrer"
              href="https://www.facebook.com/orchidgroupibiza"
              target="blank"
            >
              <FaFacebook />
            </a>
          </li>
          <li>
            <a
              rel="noreferrer"
              href="https://www.instagram.com/tog.properties/"
              target="blank"
            >
              <FaInstagram />
            </a>
          </li>
          <li>
            <a
              href="https://www.youtube.com/channel/UCMcgcfQXRbMuSD_CUkx-glQ"
              target="blank"
              rel="noreferrer"
            >
              <FaYoutube />
              <span className="sr-only">Youtube: The Orchid Properties</span>
            </a>
          </li>
        </ul>
      </div>
      <div className="grid grid-cols-2 justify-items-stretch">
        <div className="text-xs text-white">
          <h5 className="pb-4 text-white font-semibold">Quick Links</h5>
          <ul className="grid gap-2">
            {menu.map((me, key) => {
              return (
                <li key={key}>
                  <Link to={me.to}>{me.title}</Link>
                </li>
              )
            })}
          </ul>
        </div>

        <div className="text-xs text-white justify-self-end lg:justify-self-start">
          <h5 className="pb-4 text-white font-semibold">Our Services</h5>
          <ul className="grid gap-2">
            {service.map((me, key) => {
              return (
                <li key={key}>
                  <Link to={me.to}>{me.title}</Link>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
      <div>
        <h5 className="text-2xl font-bold text-white">
          Subscribe to our newsletter
        </h5>
        <p className="text-xs text-gray-300 py-2">
          Receive the best property ideas by email
        </p>
        <form>
          <div className="flex">
            <label className="sr-only" htmlFor="email">
              Email Newsletter
            </label>
            <input
              className="w-4/6 py-3 text-sm px-6 bg-white outline-none focus:outline-none"
              type="email"
              placeholder="Enter your email"
            />
            <button className="w-2/6 bg-secondry text-primary uppercase text-center text-sm font-bold">
              Send
            </button>
          </div>
        </form>
        <div className="text-xs uppercase text-white py-4">
          © {new Date().getFullYear()}, All rights reserved.
        </div>
      </div>
    </div>
  </footer>
)

Footer.propTypes = {
  siteTitle: PropTypes.string,
}

Footer.defaultProps = {
  siteTitle: ``,
}

export default Footer
